export const planetChartData = {
  type: 'doughnut',
  data: {
    labels: ['Enero', 'Febrero', 'Marzsso'],
    datasets: [




    ]
  },
  options: {
    responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    cutoutPercentage: 5,
    scales: {

    },
    tooltips: {
      callbacks: {
        label: function (item, data) {
          return data.datasets[item.datasetIndex].label + ": " + data.labels[item.index] + ": " + data.datasets[item.datasetIndex].data[item.index];
        }
      }
    }
  }
}

export default planetChartData;